import { type ReactNode } from 'react';
import { ClickAwayListener, Tooltip } from '@monorepo/nova-ui';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset } from '../credit-events.types';
import CreditAssetSelector from './credit-asset-selector';

interface RedeemCreditsTooltipProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  cartAssets?: CreditCartAsset[];
  onApply?: (asset: OptionalAssets) => void;
  onNewOrder: () => void;
  offset?: [number, number];
}

const RedeemCreditsTooltip = ({
  open,
  onClose,
  children,
  cartAssets,
  onApply,
  onNewOrder,
  offset = [0, 8],
}: RedeemCreditsTooltipProps) => (
  <ClickAwayListener onClickAway={onClose}>
    <span>
      <Tooltip
        open={open}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        title={
          cartAssets &&
          onApply && (
            <CreditAssetSelector
              cartAssets={cartAssets}
              onApply={onApply}
              onNewOrder={onNewOrder}
            />
          )
        }
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: 'transparent',
              p: 0,
              maxWidth: 'none',
              boxShadow: 'none',
              border: 'none',
            },
          },
          popper: {
            modifiers: [
              { name: 'offset', options: { offset } },
              {
                name: 'flip',
                enabled: true,
                options: { fallbackPlacements: ['top'] },
              },
            ],
          },
        }}
      >
        <span>{children}</span>
      </Tooltip>
    </span>
  </ClickAwayListener>
);

export default RedeemCreditsTooltip;
